export default "__VITE_ASSET__5b3c0083__"